import {WordFix} from '../form-features/labels/WordFix';

export const innecontainerPrefix = (prefix) => {
    if (prefix)
        return `
        > div {
            display: flex;
            align-items:center;
            ${WordFix}{
                border-radius:  var(--form-input-radius) 0 0 var(--form-input-radius);
            }
        }
        // -- Focus setup -- 
        .dropdown-select__control.dropdown-select__control--is-focused,
        input:focus,
        select:focus
        {
            border-radius: 0 var(--form-input-radius) var(--form-input-radius) 0;
        }
    `;
    else
        return `
       
        `;
};

export const innerContainerPrefix = (prefix) => {
    if (prefix)
        return `
        border-left: none;
        border-radius:  0 var(--form-input-radius)  var(--form-input-radius) 0;
    
        .fk-radio-select__control,
        .fk-radio-select__control--is-focused,
        .fk-radio-select__control--menu-is-open,
        .fk-radio-select__control:hover {
            border-left: none;
            border-radius:  0 var(--form-input-radius)  var(--form-input-radius) 0;
        }
    `;
    else return ``;
};
